import React from "react";

const Tools = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 text-black">
      <h1 className="text-4xl font-bold mb-4">WORKING...</h1>
      <p className="text-xl text-center max-w-xl">React, Firebase, Tailwind</p>
    
    </div>
  );
};

export default Tools;
